import {
  isLocalDev,
  isImagitasDev,
  isImagitasTest,
  isImagitasPreprod,
} from '@mgo/core/src/environment';

const GTM_ENVIRONMENTS = {
  next: {
    container: 'GTM-PVMPX8LZ',
    env: 2,
    auth: 'kzW4AXRJRv2n1Av_YE2FDQ',
  },
  live: {
    container: 'GTM-PVMPX8LZ',
    env: null,
    auth: null,
  },
};

const getGTMConfig = () => {
  const origin = window.location.href;
  switch (true) {
    case isLocalDev(origin):
    case isImagitasDev(origin):
    case isImagitasTest(origin):
    case isImagitasPreprod(origin):
      // eslint-disable-next-line no-console
      console.log('Not production GTM');
      return GTM_ENVIRONMENTS.next;
    default:
      return GTM_ENVIRONMENTS.live;
  }
};

export default function () {
  const config = getGTMConfig();
  const s = document.createElement('script');

  if (config.env === null) {
    s.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${config.container}');
    `;
  } else {
    s.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${config.auth}&gtm_preview=env-${config.env}&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${config.container}');
    `;
  }

  const noScript = document.createElement('noscript');

  // Only add environment parameters to noscript if they exist
  if (config.env === null) {
    noScript.innerHTML = `
  <iframe src="https://www.googletagmanager.com/ns.html?id=${config.container}"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
  } else {
    noScript.innerHTML = `
  <iframe src="https://www.googletagmanager.com/ns.html?id=${config.container}&gtm_auth=${config.auth}&gtm_preview=env-${config.env}&gtm_cookies_win=x"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
  }

  document.head.appendChild(s);
  document.body.appendChild(noScript);
}
